export default {
  // #region receiveslip
  GET_LIST_RECEIVESLIP_REQUEST: 'GET_LIST_RECEIVESLIP_REQUEST',
  GET_LIST_RECEIVESLIP_SUCCESS: 'GET_LIST_RECEIVESLIP_SUCCESS',
  GET_LIST_RECEIVESLIP_FAILURE: 'GET_LIST_RECEIVESLIP_FAILURE',

  GET_DETAIL_RECEIVESLIP_REQUEST: 'GET_DETAIL_RECEIVESLIP_REQUEST',
  GET_DETAIL_RECEIVESLIP_SUCCESS: 'GET_DETAIL_RECEIVESLIP_SUCCESS',
  GET_DETAIL_RECEIVESLIP_FAILURE: 'GET_DETAIL_RECEIVESLIP_FAILURE',

  CREATE_REQUEST: 'CREATE_REQUEST',
  CREATE_SUCCESS: 'CREATE_SUCCESS',
  CREATE_FAILURE: 'CREATE_FAILURE',

  UPDATE_REQUEST: 'UPDATE_REQUEST',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_FAILURE: 'UPDATE_FAILURE',

  DELETE_REQUEST: 'DELETE_REQUEST',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_FAILURE: 'DELETE_FAILURE',

  GET_LIST_ORDER_REQUEST: 'GET_LIST_ORDER_REQUEST',
  GET_LIST_ORDER_SUCCESS: 'GET_LIST_ORDER_SUCCESS',
  GET_LIST_ORDER_FAILURE: 'GET_LIST_ORDER_FAILURE',

  GET_CODE_RECEIVESLIP_SUCCESS: 'GET_CODE_RECEIVESLIP_SUCCESS',
  GET_CODE_RECEIVESLIP_REQUEST: 'GET_CODE_RECEIVESLIP_REQUEST',
  GET_CODE_RECEIVESLIP_FAILURE: 'GET_CODE_RECEIVESLIP_FAILURE',

  GET_ORDER_SUCCESS: 'GET_ORDER_SUCCESS',
  GET_ORDER_REQUEST: 'GET_ORDER_REQUEST',
  GET_ORDER_FAILURE: 'GET_ORDER_FAILURE',
  // #endregion
};
